import React, { useEffect, useState, useCallback } from 'react';
import { faArrowLeft, faCheck, faEye, faFile, faFileAlt, faPencilAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Row } from 'reactstrap';
import moment from 'moment';

// Components
import TabelaListagemFichas from '../../../components/TabelaListagemFichas/TabelaListagemFichas';
import TextField from '../../../components/TextField/TextField';

// Helpers
import { abrirPDF } from '../../../helpers/abrirPDF';

//Context
import { useAuth } from '../../../context/auth';


export default function FichaContainerPGRS({
  pgrs,
  setActiveStep,
  activeStep,
  finalizar = false,
  impressaoFicha,
  onSubmit = () => { },
  onSubmitAcoesGestor = () => { }
}) {
  const { session } = useAuth();

  //Estado para analise do PGRS do gestor
  const [observacoes, setObservacoes] = useState("");

  const [blocos, setBlocos] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [analises, setAnalises] = useState([])

  const headersContratos = [
    { value: "Transportador", objectValue: "nomeFantasiaTransportador", align: "left" },
    { value: "Endereço", objectValue: "endereco", align: "left" },
    { value: "Tipo de Coleta", objectValue: "modalidade", align: "left" },
    {
      value: "PGRS Obrigatório", objectValue: "pgrsObrigatorio", align: "left"
    },
    { value: "Frequência", objectValue: "frequencia", align: "left" },
    { value: "Volumetria", objectValue: "volumetria", align: "left" },
    { value: "Quantidade Contratada", objectValue: "quantidadeContratada", align: "left" },
  ];

  const headersQuestao = [
    { value: "Descrição", objectValue: "descricao", align: "left" },
    { value: "Valor", objectValue: "valor", align: "left" }
  ];

  const headersAnalises = [
    { value: "Status", objectValue: "status", align: "left" },
    { value: "Data", objectValue: "dataHora", align: "left" },
    ...((session?.acesso?.sigla == "GS") ? [{ value: "Usuário", objectValue: "usuario", align: "left" }] : []),
    ...((!impressaoFicha) ? [{ value: "Observação", objectValue: "observacoes", align: "left" }] : []),
  ];

  const loadDocumentos = useCallback(() => {
    setDocumentos(pgrs?.tbPGRSGeradorDocumentos ?? []);
  }, [pgrs]);

  const loadBlocos = useCallback(() => {
    setBlocos(
      pgrs.tbPGRSGeradorBlocos?.map(item => {
        return {
          ...item,
          tbPGRSGeradorBlocoQuestos: item.tbPGRSGeradorBlocoQuestos?.map(questao => ({
            ...questao,
            valor: questao.tipoValor === "Data" ? !!questao.valor ? moment(questao.valor).format("DD/MM/YYYY") : "" : questao.valor
          }))
        };
      }) ?? []
    );
  }, [pgrs]);

  const loadAnalisesPGRS = useCallback(() => {
    setAnalises(pgrs.tbPGRSAnalises?.map(item => {
      return {
        ...item,
        dataHora: moment(item.dataHora).format("DD/MM/YYYY HH:mm:ss")
      };
    }) ?? [])
  }, [pgrs]);

  useEffect(() => {
    loadBlocos();
    loadDocumentos();

    loadAnalisesPGRS();

  }, [loadBlocos, loadDocumentos, loadAnalisesPGRS,]);

  return (
    <div style={{ color: "#666" }}>
      <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
        <span><FontAwesomeIcon icon={faPencilAlt} className="me-2" /> Identificação do PGRS</span>
      </h5>

      <Row>
        <Col md="12" lg="12">
          <p><span className="fw-bold">Identificação: </span>{pgrs.identificacao ?? "Não informado"}</p>
        </Col>
      </Row>

      {blocos.map((item, index) => (
        <div className='w-100' key={index}>
          <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
            <span><FontAwesomeIcon icon={faFile} className="me-2" /> {item.bloco_descricao}</span>
          </h5>
          <Row>
            <TabelaListagemFichas
              headers={headersQuestao}
              items={item.tbPGRSGeradorBlocoQuestos}
              width={"100"}
              widthPDF='100%'
            />
          </Row>
        </div>
      ))}

      <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
        <span><FontAwesomeIcon icon={faFile} className="me-2" /> Contratos</span>
      </h5>
      <Row>
        <TabelaListagemFichas
          headers={headersContratos}
          items={pgrs.contratosPendentes.filter(x => x.contratoPendentePGRS == true)}
          width={"100"}
          widthPDF='100%'
        />
      </Row>

      {!impressaoFicha &&
        <>
          <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
            <span><FontAwesomeIcon icon={faFile} className="me-2" /> Documentos</span>
          </h5>
          <Row>
            {documentos.map((documento, index) => (
              <Col lg={3} key={index} className="mb-3">
                <div className="card shadow h-100">
                  <div className="card-body d-flex flex-column justify-content-center align-items-center text-center">
                    <div className="d-flex flex-column align-items-center">
                      <label htmlFor={`file-upload-${index}`} className="mb-3">
                        <FontAwesomeIcon icon={faFileAlt} className="text-success" size="4x" />
                      </label>
                    </div>

                    <div className="mb-3">
                      <strong>{documento.identificacao || "Documento"}</strong>
                    </div>

                    <button className="btn btn-primary btn-sm mt-auto" onClick={() => {
                      if (documento.arquivo.includes(".pdf"))
                        window.open(documento.arquivo, "_blank");
                      else
                        abrirPDF(documento.arquivo);
                    }}>
                      <FontAwesomeIcon icon={faEye} /> Visualizar
                    </button>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </>
      }

      {analises.length > 0 &&
        <>
          <h5 className="bg-primary bg-gradient p-2 rounded-3 d-flex justify-content-between align-items-center" style={{ color: "#fff" }}>
            <span><FontAwesomeIcon icon={faFile} className="me-2" /> Análise do PGRS</span>
          </h5>
          <Row>
            <TabelaListagemFichas
              headers={headersAnalises}
              items={analises ?? []}
              width={"100"}
              widthPDF='100%'
            />
          </Row>
        </>}

      <div className='d-flex align-items-center justify-content-center gap-1 mt-3'>
        {finalizar && (
          <>
            <Button outline color='success' className='me-4 bg-gradient d-flex align-items-center' onClick={() => setActiveStep(activeStep - 1)}>
              <FontAwesomeIcon icon={faArrowLeft} className={"me-3"} /> Anterior
            </Button>

            <Button color='success' onClick={() => onSubmit("Pendente")}>
              <FontAwesomeIcon icon={faCheck} className={"me-3"} /> Salvar
            </Button>
          </>
        )}
      </div>

      {pgrs &&
        session?.acesso?.sigla == "GS" &&
        <>
          <Row>
            <Col md="12" lg="12">
              <TextField
                maxLength={"1000"}
                type={"textarea"}
                label={"Observações"}
                name={"observacoes"}
                value={observacoes}
                onChange={(e) => setObservacoes(e.target.value)}
              />
            </Col>
          </Row>
          <div className='d-flex align-items-center justify-content-center gap-1 mt-3'>
            {pgrs.statusAnalise == "Aguardando Análise" &&
              <Button color='success' onClick={() => onSubmitAcoesGestor({ status: "Aprovado", observacoes: observacoes, tbPGRSGerador_Id: pgrs.id })}>
                <FontAwesomeIcon icon={faCheck} className={"me-3"} /> Aprovar
              </Button>
            }
            {((pgrs.statusAnalise == "Aguardando Análise") || (pgrs.statusAnalise == "Aprovado" || pgrs.statusAnalise == "Aprovado Automaticamente")) &&
              <Button color='danger' onClick={() => onSubmitAcoesGestor({ status: "Reprovado", observacoes: observacoes, tbPGRSGerador_Id: pgrs.id })}>
                <FontAwesomeIcon icon={faTimes} className={"me-3"} /> Reprovar
              </Button>
            }
          </div>
        </>
      }

    </div>
  );
}
